// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import Home from './pages/Home';
import Product from './pages/Product';
import Employers from './pages/Employers';
import Brokers from './pages/Brokers';
import CFOs from './pages/CFOs';
import About from './pages/About';
import CaseStudies from './pages/CaseStudies';
import CaseStudyDetail from './pages/CaseStudyDetail';
import Labs from './pages/Labs';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogEditor from './pages/BlogEditor';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Conference from "./pages/Conference";
import './App.css';
import './Blog.css';
// In your App.js routes, add:
import Unsubscribe from './pages/Unsubscribe';
// External redirect component
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

// Layout wrapper for pages with Navbar/Footer
const MainLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="landing">
          <Routes>
            {/* Labs page - standalone, no navbar/footer */}
            <Route path="/" element={<MainLayout><Home /></MainLayout>} />
            <Route path="/labs" element={<Labs />} />

            {/* Main site pages with navbar/footer */}
            <Route path="/home" element={<MainLayout><Home /></MainLayout>} />
            <Route path="/product" element={<MainLayout><Product /></MainLayout>} />
            <Route path="/solutions/employers" element={<MainLayout><Employers /></MainLayout>} />
            <Route path="/solutions/brokers" element={<MainLayout><Brokers /></MainLayout>} />
            <Route path="/solutions/cfos" element={<MainLayout><CFOs /></MainLayout>} />
            <Route path="/about" element={<MainLayout><About /></MainLayout>} />
            <Route path="/case-studies" element={<MainLayout><CaseStudies /></MainLayout>} />
            <Route path="/case-studies/:slug" element={<MainLayout><CaseStudyDetail /></MainLayout>} />
            <Route path="/conference" element={<MainLayout><Conference /></MainLayout>} />

            <Route path="/unsubscribe" element={<Unsubscribe />} />


            {/* Blog pages */}
            <Route path="/blog" element={<MainLayout><Blog /></MainLayout>} />
            <Route path="/blog/new" element={<MainLayout><BlogEditor /></MainLayout>} />
            <Route path="/blog/edit/:id" element={<MainLayout><BlogEditor /></MainLayout>} />
            <Route path="/blog/:id" element={<MainLayout><BlogPost /></MainLayout>} />

            {/* Other pages */}
            <Route path="/contact" element={<ExternalRedirect to="https://app.youform.com/forms/kheawp2d" />} />
            <Route path="/privacy" element={<MainLayout><PrivacyPolicy /></MainLayout>} />
            <Route path="/terms" element={<MainLayout><TermsOfUse /></MainLayout>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;